import styled from 'styled-components';

const DEFAULT_DATE_VALUE = '1970';

export const ChildWrapper = styled.div`
  flex: 1 1 220px;
  min-width: 220px;
`;

export const FilterElement = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px 16px;
  background-color: #f4f7fb;
  border: 1px solid #e6ecf9;
  border-radius: 4px;
  width: 100%;
  padding: 16px;
  position: relative;
`;

export const TooltipWrapper = styled.div`
  z-index: 4;
  padding-right: 0;
  margin-top: 3px;
`;

export const FilterInfoWrapper = styled.div`
  margin-left: auto;
  display: flex;
  justify-content: end;
  align-content: center;
  padding-bottom: 8px;
`;

export const InfoText = styled.div`
  color: #29354b;
  margin-right: 2px;
`;

export const RemoveFilter = styled.div`
  position: absolute;
  top: -10px;
  right: -8.5px;
`;

export const ToggleCheckboxWrapper = styled.div`
  width: 100%;
  height: 44px;
`;

export const getDateFilterText = (date) => {
  const filterDate = new Date(date);
  const dateFilterText = filterDate.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC',
  });

  return dateFilterText.includes(DEFAULT_DATE_VALUE) ? '' : dateFilterText;
};

export const getFiltersNumberText = (number) => {
  return number > 1 ? `${number} filters applied` : '1 filter applied';
};

export const parseDate = (date, isStart) => {
  const padZeros = (number) => {
    return `0${number}`.slice(-2);
  };
  const dateString = `${date.getFullYear()}-${padZeros(date.getMonth() + 1)}-${padZeros(date.getDate())}T${
    isStart === true ? '00:00:00.000' : '23:59:59.000'
  }Z`;
  return dateString;
};
